import { createEnumMap } from 'Commons/helpers/utils/Formatter';

export const HIGHLIGHT_TYPE = createEnumMap(['half', 'half_on_hover', 'default'], key => key.toUpperCase());

export const EMPTY_LIST = [];
